import useSWR from 'swr';
import { type AxfoodBasicProductViewModel, ComponentV2 } from '@occ/api-client';
import useCustomer from '@hooks/useCustomer';
import useStore from '@hooks/useStore';

const api = new ComponentV2({
  baseUrl: '',
});

const fetcher = async (componentId: string) => {
  const response = await api.getProductsForTwoTilesProductBannerV2(componentId);
  // swagger response type incorrect - typecast
  return response.data as unknown as {
    products?: Array<AxfoodBasicProductViewModel>;
    componentNotFound?: string;
  };
};

const useTwoTilesProducts = (componentId: string, show: boolean) => {
  const { store } = useStore();
  const { customer } = useCustomer();
  const storeId = store?.storeId;
  const shouldFetch = show && Boolean(customer);

  const key = {
    endpoint: '/twoTilesButtonAndProductBannerComponent',
    componentId,
    customerId: customer?.uid,
    storeId,
  };

  const { data, isLoading } = useSWR(shouldFetch ? key : null, ({ componentId }) => fetcher(componentId));

  return {
    showSpinner: isLoading,
    products: data?.products ?? [],
  };
};

export default useTwoTilesProducts;
